import { OrganizationListState } from 'src/react/organization/state/OrganizationListState';

export const ORGANIZATION_LIST_DEFAULT_STATE: OrganizationListState = {
    modalState: { type: 'none' },
    organizations: null,
};
